import { jsx as _jsx } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { NextSeo } from "next-seo";
import { memo } from "react";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { createShortUrlBoardRoute } from "~/constants/routes";
import { getSeoTitle } from "~/swr-hooks/shortUrl/utils";
export const PublicBoardSEO = /*#__PURE__*/ memo((param)=>{
    let { board } = param;
    const { workspaceName } = usePublicWorkspace();
    const { shortId } = useShortIdContext();
    const url = "https://app.air.inc".concat(createShortUrlBoardRoute(shortId, board.id));
    const thumbnail = board.thumbnails[0];
    var _board_description;
    return /*#__PURE__*/ _jsx(NextSeo, {
        nofollow: true,
        noindex: true,
        title: getSeoTitle("Board", board.title, workspaceName),
        description: (_board_description = board.description) !== null && _board_description !== void 0 ? _board_description : undefined,
        canonical: url,
        openGraph: {
            url,
            images: !!thumbnail ? [
                {
                    url: thumbnail,
                    alt: ""
                }
            ] : undefined
        }
    });
});
PublicBoardSEO.displayName = "PublicBoardSEO";
